import './sub_title.scss';

function SubTitle(props) {
  return <h2 className="smc-TrackingDelivery-subtitle">{props.children}</h2>;
}

export default SubTitle;
